/**
 * Enum management for CDP SDK.
 */

import { CDPSession, getSession } from '../session';

export class EnumManager {
  constructor(private readonly session: CDPSession = getSession()) {}

  async listEnumTypes(params?: Record<string, any>): Promise<Record<string, any>> {
    return this.session.get('/api/mdp/enum/enumtype', { params });
  }

  async listEnumItems(params?: Record<string, any>): Promise<Record<string, any>> {
    return this.session.get('/api/cdp/cdp_enum_type/share/enum_items', { params });
  }

  async pageEnums(page = 1, size = 20, params?: Record<string, any>): Promise<Record<string, any>> {
    return this.session.get('/api/cdp/cdp_enum_type/page2', {
      params: { current: page, size, ...params },
    });
  }
}
